import Keycloak from 'keycloak-js';
import { config } from './runtime-config';

function resolveKeycloakUrl(): string {
  // Runtime first so one published image serves any environment; the build-time
  // value stays the fallback for dev and the platform bundle.
  const raw = config('KEYCLOAK_URL', import.meta.env.VITE_KEYCLOAK_URL || 'https://172.27.23.146:8443').trim();
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw.replace(/\/+$/, '');
  }

  throw new Error(
    'Keycloak URL is not a valid http(s) URL. Set KEYCLOAK_URL on the web ' +
      'container, or VITE_KEYCLOAK_URL at build time.',
  );
}

const keycloakConfig = {
  url: resolveKeycloakUrl(),
  realm: config('KEYCLOAK_REALM', import.meta.env.VITE_KEYCLOAK_REALM) || 'EthioCert',
  clientId: config('KEYCLOAK_CLIENT_ID', import.meta.env.VITE_KEYCLOAK_CLIENT_ID) || 'platform-web',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
